export default "/images/vendor/@coreui/icons/svg/flag/cif-nr.svg?bd9454bd141fcd4af970839f5215b3f6";